import { RecoverableBinding, recoverableField } from "../../../ServiceDesk/recovery/recoverable-control";

export class SearchBinding extends RecoverableBinding {
  /** The text which is displayed as placeholder in the search control */
  public placeholder = "@?";

  /** fn called when either the search button is clicked or enter key is pressed. Parameter '{ searchText: string }' is passed to the function. */
  public onSearch = "&";

  /** fn called when the search text changes in the control. Parameter '{ searchText: string }' is passed to the function. */
  public onChange = "&?";

  /** fn called when the search text input is focused. Parameter '{ searchText: string }' is passed to the function. */
  public onFocus = "&?";

  /** fn called when the search text input is focused. Parameter '{ searchText: string }' is passed to the function. */
  public onBlur = "&?";

  /** search text in the control is bind to this*/
  public searchText = "=?";

  /** hides the default search button if set to true */
  public hideSearchButton = "<?";

  /** The identifier for all business intelligence (BI) actions triggered by this component.*/
  public biId = "@?";

  /** Set to true to disable the control. */
  public isDisabled = "<?";

  public ariaLabelledby = "@";

  public ariaLabel = "@?";
}

export class SearchController {
  public placeholder: string;
  public onChange: any;
  public onFocus: any;
  public onBlur: any;
  @recoverableField
  public searchText: string;
  public onSearch: any;
  public hideSearchButton: boolean;
  public biId: string;

  public onEnterKeyPressed($event: any) {
    if (this.hideSearchButton && $event.keyCode == 13) {
      this.onSearchButtonClick();
    }
  }

  $sdRecoveryOnComplete(data: any) {
    this.onInputChange();
  }

  public onSearchButtonClick(): void {
    if (this.onSearch) {
      this.onSearch({ searchText: this.searchText });
    }
  }

  public onInputChange(): void {
    if (this.onChange) {
      this.onChange({ searchText: this.searchText });
    }
  }
  public onInputFocus(): void {
    if (this.onFocus) {
      this.onFocus({ searchText: this.searchText });
    }
  }
  public onInputBlur(): void {
    if (this.onBlur) {
      this.onBlur({ searchText: this.searchText });
    }
  }
}
export const sdSearch: ng.IComponentOptions = {
  bindings: <any>new SearchBinding(),
  controller: SearchController,
  templateUrl: "../ShellCommon/Controls/search/search.html"
};
